var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// $FlowFixMe
import resources from 'app/store/resources';
export default (_a) => __awaiter(void 0, [_a], void 0, function* ({ projectId }) {
    const params = (progressKey) => ({
        params: {
            queries: { page_size: 1000 },
            headers: { [window.OVM_PROJECT_HEADER]: projectId || '' },
        },
    });
    yield Promise.all([
        resources.assetsCustomAttributValues.fetch('category', {}),
        resources.steps.fetchAll(params('steps')),
        resources.attributes.fetchAll(params('attributes')),
        resources.assets.fetchAll({
            params: {
                queries: { page_size: 1000, assetType: 'pj' },
            },
        }),
    ]);
});
